import { Org } from 'types/orgInfoTypes';

export const createOrg = (): Org => ({
  name: '',
  location: '',
  staffCount: 'small',
});

export const createOrgMock = (): Org => ({
  name: 'ООО Компания',
  location: 'BY',
  staffCount: 'small',
});
